import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLayers = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.638 3.574 3.554 7.347a.047.047 0 0 0-.015.064.1.1 0 0 0 .014.015l8.084 3.745a.93.93 0 0 0 .725 0l8.085-3.773a.047.047 0 0 0 .015-.065.1.1 0 0 0-.015-.014l-8.084-3.745a.93.93 0 0 0-.725 0M11.033 2.2a2.43 2.43 0 0 1 1.935 0l.016.007 8.112 3.758.022.01a1.547 1.547 0 0 1-.02 2.773l-8.112 3.787-.018.008a2.43 2.43 0 0 1-1.935 0l-.017-.008L2.904 8.78l-.022-.011a1.547 1.547 0 0 1 .02-2.773l8.112-3.786zm10.898 9.981a.75.75 0 0 1-.367.995l-8.68 4-.003.001a2.17 2.17 0 0 1-1.804 0l-.004-.002-8.638-3.999a.75.75 0 0 1 .63-1.361l8.635 3.997.001.001a.67.67 0 0 0 .556 0h.001l8.678-3.999a.75.75 0 0 1 .995.367m-.367 5.621a.75.75 0 0 0-.628-1.362l-8.678 3.998a.67.67 0 0 1-.557.001H11.7l-8.634-3.998a.75.75 0 0 0-.63 1.36l8.638 4 .004.002a2.17 2.17 0 0 0 1.804 0l.002-.001z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLayers;
